const utils = {
  // 获取域名
  // domain : document.domain,
  domain: "m.evyun.cn",
  // 获取协议
  port: document.location.protocol == "https:" ? ":12702" : ":12701",
  // 请求接口域名
  baseUrl: this.domain + this.port,
  // 查询字符串参数
  getQueryStringArgs: () => {
    let qs = location.search.length > 0 ? location.search.substring(1) : "",
      args = {},
      items = qs.length > 0 ? qs.split("&") : [],
      item = null,
      name = null,
      value = null,
      i = 0,
      len = items.length;
    for (i; i < len; i++) {
      item = items[i].split("=");
      name = decodeURIComponent(item[0]);
      value = decodeURIComponent(item[1]);
      if (name.length) {
        args[name] = value;
      }
    }
    return args;
  },
  // 查询cookie参数
  getCookieStringArgs: () => {
    const cs = document.cookie.length > 0 ? document.cookie.replace(/\s/g, "") : "";
    // const cs = this.getCookie().replace(/\s/g, ""); // 获取本地模拟cookies
    let args = {},
      items = cs.length > 0 ? cs.split(";") : [],
      item = null,
      name = null,
      value = null,
      i = 0,
      len = items.length;
    for (i; i < len; i++) {
      item = items[i].split("=");
      name = decodeURIComponent(item[0]);
      value = decodeURIComponent(item[1]);
      if (name.length) {
        args[name] = value;
      }
    }
    return args;
  },
  // 本地模拟获取cookie登录状态
  getCookie: () => {
    // 未登录
    // const cookies = "";
    // 别人
    // const cookies = "zz_userid=21062530;zz_shellCode=31d1791fe6c4d41cd202767760c9d581";
    // 自己
    const cookies = "zz_userid=21263772;zz_shellCode=c76676e680a08b9f0af490035b39396e;";
    return cookies;
  },
  // 判断是否为微信环境，执行不同的操作
  isWeChat: (wechatFn, otherFn) => {
    const ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      wechatFn()
    } else {
      otherFn()
    }
  },
  // 防抖
  debounce: (func, wait, immediate) => {
    let timeout;
    return function () {
      let context = this, args = arguments;
      let later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      let callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  },
  // 节流
  throttle: (func, wait, mustRun) => {
    let timeout, startTime = new Date();
    return function () {
      let context = this,
        args = arguments,
        curTime = new Date();

      clearTimeout(timeout);
      // 如果达到了规定的触发时间间隔，触发 handler
      if (curTime - startTime >= mustRun) {
        func.apply(context, args);
        startTime = curTime;
        // 没达到触发间隔，重新设定定时器
      } else {
        timeout = setTimeout(func, wait);
      }
    };
  }
}
export default utils


//////////////////
// WEBPACK FOOTER
// ./static/js/b_utils.js
// module id = null
// module chunks = 